import React, { FC, useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import Select from 'react-select';
import { fetchData, hasSpecialCharacters, isSpecificSpecialCharacters, toasterrormsg, toastsuccessmsg } from '../../../reusable';
import { ToastContainer } from 'react-toastify';
import { AddTourPackageHeader } from './AddTourPackageHeader';
import PhoneInput from 'react-phone-input-2';
import { Tr } from '../../../_metronic/i18n/Tr';
import Swal from 'sweetalert2';
import { KTIcon } from '../../../_metronic/helpers';

const AddTourPackageBasicInfo: FC = () => {

    const t = Tr()
    const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId')
    useEffect(() => {
        if (categoryId != '5') {
            navigate('../dashboard/');
        }
    }, [categoryId])
    const location = useLocation();
    const editTourpackageId = (location.state as any)?.tourpackageId || '';

    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;

    } else {
        console.log("No vendor data found");
    }
    const [loading, setLoading] = useState(false)
    const [disable, setDisable] = useState(false);
    const [tourPackageDetails, setTourPackageDetails] = useState([]);
    const [tourAgencyNameEN, setTourAgencyNameEN] = useState("");
    const [tourAgencyNameRU, setTourAgencyNameRU] = useState("");
    const [tourAgencyNameUZ, setTourAgencyNameUZ] = useState("");
    const [contactPersonName, setContactPersonName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("998");
    const [isFieldDisable, setIsFieldDisable] = useState({
        tourAgencyNameEN: false,
        tourAgencyNameRU: false,
        tourAgencyNameUZ: false,
        contactPersonName: false,
    }) as any
    const [primaryLanguageList] = useState([
        { value: 'English', label: 'English' },
        { value: 'Russian', label: 'Русский' },
        { value: 'Uzbek', label: 'O’zbekcha' },
    ]);
    const [primaryLanguageSelectedOptions, setPrimaryLanguageSelectedOptions] = useState<any>({ value: 'English', label: 'English' });
    sessionStorage.setItem("primaryLanguage", primaryLanguageSelectedOptions.value);

    // service language list state end
    const changePrimaryLanguage = (val: any) => {
        setPrimaryLanguageSelectedOptions(val);
        removeError("primaryLanguage");
        sessionStorage.setItem("primaryLanguage", val.value);
    }

    const [socialMediaChannelList] = useState([
        { label: 'Instagram', value: 'Instagram' },
        { label: 'Facebook', value: 'Facebook' },
        { label: 'Linkedin', value: 'Linkedin' },
        { label: 'TikTok', value: 'TikTok' },
        { label: 'YouTube', value: 'YouTube' },
        { label: 'Website', value: 'Website' }]);

    const [socialMediaFields, setSocialMediaFields] = useState([
        { socialMediaType: '', socialMediaLink: '' }
    ]);
    const [errors, setErrors] = useState([{
        socialMediaType: '',
        socialMediaLink: '',
    }]);

    const removeErrors = (index: any, fieldName: any) => {
        let newError = [...errors] as any;
        if (!newError[index]) {
            newError[index] = {};
        }
        newError[index][fieldName] = ''; // Clear error
        setErrors(newError);
    };
    const handleAddField = () => {
        setSocialMediaFields([...socialMediaFields, { socialMediaType: '', socialMediaLink: '' }]);
    };

    const handleRemoveField = (index: any) => {
        const updatedFields = socialMediaFields.filter((_, i) => i !== index);
        setSocialMediaFields(updatedFields);
    };

    const handleChange = (index: any, field: any, value: any) => {
        const updatedFields = [...socialMediaFields] as any;
        updatedFields[index][field] = value;
        setSocialMediaFields(updatedFields);
        removeErrors(index, field); // Clear the error for the updated field
    };

    const getFilteredOptions = (currentIndex: any) => {
        const selectedValues = socialMediaFields.map((field, index) => index !== currentIndex ? field.socialMediaType : '');
        return socialMediaChannelList.filter(option => !selectedValues.includes(option.value));
    };
    // set error state
    const [error, setError] = useState([{
        tourAgencyNameEN: '',
        tourAgencyNameRU: '',
        tourAgencyNameUZ: '',
        contactPersonName: '',
        email: '',
        phoneNumber: '',
        primaryLanguage: '',
    }])

    // remove validation function
    const removeError = (err: any) => {
        var tmp = [...error] as any;
        tmp[0][err] = "";
        setError(tmp);
    }

    // validation function
    const validate = () => {

        var isValid = true;
        var errorTmp = [...error];

        if (primaryLanguageSelectedOptions.value == "English") {

            if (tourAgencyNameEN.trim() == "" || tourAgencyNameEN.trim() == null || tourAgencyNameEN.trim() == undefined) {
                errorTmp[0].tourAgencyNameEN = t('Tour Agency Name Is Required');
                isValid = false;
            } 
            // else if (!isSpecificSpecialCharacters(tourAgencyNameEN.trim())) {
            //     errorTmp[0].tourAgencyNameEN = t("Only <>,.'*() type Of Special Character Are Allow.");
            //     isValid = false;
            // }
        } else if (primaryLanguageSelectedOptions.value == "Russian") {
            if (tourAgencyNameRU.trim() == "" || tourAgencyNameRU.trim() == null || tourAgencyNameRU.trim() == undefined) {
                errorTmp[0].tourAgencyNameRU = t('Tour Agency Name Is Required');
                isValid = false;
            }
            // else if (!hasSpecialCharacters(tourAgencyNameRU.trim())) {
            //     errorTmp[0].tourAgencyNameRU = t('Special Characters Is Not Allow');
            //     isValid = false;
            // }
        } else if (primaryLanguageSelectedOptions.value == "Uzbek") {
            if (tourAgencyNameUZ.trim() == "" || tourAgencyNameUZ.trim() == null || tourAgencyNameUZ.trim() == undefined) {
                errorTmp[0].tourAgencyNameUZ = t('Tour Agency Name Is Required');
                isValid = false;
            }
            //  else if (!hasSpecialCharacters(tourAgencyNameUZ.trim())) {
            //     errorTmp[0].tourAgencyNameUZ = t('Special Characters Is Not Allow');
            //     isValid = false;
            // }
        }
        if (contactPersonName.trim() == "" || contactPersonName.trim() == null || contactPersonName.trim() == undefined) {
            errorTmp[0].contactPersonName = t('Person Name Is Required');
            isValid = false;
        } else if (!hasSpecialCharacters(contactPersonName.trim())) {
            errorTmp[0].contactPersonName = t('Special Characters Is Not Allow');
            isValid = false;
        }
        if (email == "" || email == undefined || email == null) {
            errorTmp[0].email = t('Email Is Required');
            isValid = false;
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}(?:\.[A-Z]{2,})?$/i.test(email)) {
            errorTmp[0].email = t('Please Enter Valid Email.');
            isValid = false;
        }
        if (!phoneNumber) {
            errorTmp[0].phoneNumber = t('Mobile Number Is Required');
            isValid = false;
        } else if (!/^\d+$/.test(phoneNumber)) {
            errorTmp[0].phoneNumber = t('Only Numbers Are Allowed.');
            isValid = false;
        } else {
            // Remove non-numeric characters (like + or spaces)
            const numericPhone = phoneNumber.replace(/\D/g, '');
            // Validate phone number length
            if (numericPhone.length < 10 || numericPhone.length > 15) {
                errorTmp[0].phoneNumber = t('Please Enter Valid Mobile Number');
                isValid = false;
            }
        }
        let errorTmps = [...errors] as any;

        socialMediaFields.forEach((field, index) => {
            if (!errorTmps[index]) {
                errorTmps[index] = {};
            }

            // Validate socialMediaType field
            if (!field.socialMediaType) {
                errorTmps[index].socialMediaType = t('Social Media Type Is Required');
                isValid = false;
            } else {
                errorTmps[index].socialMediaType = ''; // Clear error if socialMediaType is selected
            }

            // Validate socialMediaLink field
            if (!field.socialMediaLink || !field.socialMediaLink.trim()) {
                errorTmps[index].socialMediaLink = t('Social Media Link Is Required');
                isValid = false;
            } else {
                errorTmps[index].socialMediaLink = ''; // Clear error if socialMediaLink is provided
            }
        });

        setErrors(errorTmps);
        setError(errorTmp);
        return isValid;
    }
    // add restaurant api call
    const addTourPackageApi = async () => {

        if (validate()) {
            setDisable(true)
            setLoading(true);
            let param: any = {
                vendorId: String(vendorId),
                en_agencyName: tourAgencyNameEN,
                ru_agencyName: tourAgencyNameRU,
                uz_agencyName: tourAgencyNameUZ,
                primaryLanguage: primaryLanguageSelectedOptions.value,
                email: email,
                phoneNo: phoneNumber,
                contact_person_name: contactPersonName,
                socialMediaChannels: socialMediaFields,
            }

            var res = await fetchData("public/addTourPackage", param)
            if (res.status == "200") {
                toastsuccessmsg(t("Basic Information Saved Successfully!"))
                var data = res.data[0];
                const state = {
                    tourpackageId: data['tourpackageId']
                }
                setTimeout(() => {
                    if (data.isCriticalFieldChange) {
                        navigate("../viewtourcontract/", { state });
                    } else {
                        navigate("../addtourpackagelocation/", { state });
                    }
                    setDisable(false)
                    setLoading(false)
                }, 1500);
            }
            else {
                setLoading(false)
                setDisable(false)
                toasterrormsg(res.message)
            }
        }

    }
    // edit restaurant api call
    const editTourPackageApi = async () => {

        if (validate()) {
            setDisable(true)
            setLoading(true);
            let param: any = {
                vendorId: String(vendorId),
                tourpackageId: String(editTourpackageId),
                en_agencyName: tourAgencyNameEN,
                ru_agencyName: tourAgencyNameRU,
                uz_agencyName: tourAgencyNameUZ,
                primaryLanguage: primaryLanguageSelectedOptions.value,
                email: email,
                phoneNo: phoneNumber,
                contact_person_name: contactPersonName,
                socialMediaChannels: socialMediaFields,
            }

            var res = await fetchData("public/addTourPackage", param)
            if (res.status == "200") {
                toastsuccessmsg(t("Basic Information Saved Successfully!"))
                var data = res.data[0];
                const state = {
                    tourpackageId: data['tourpackageId']
                }
                setTimeout(() => {
                    if (data.isCriticalFieldChange) {
                        navigate("../viewtourcontract/", { state });
                    } else {
                        navigate("../addtourpackagelocation/", { state });
                    }
                    setDisable(false)
                    setLoading(false);
                }, 1500);
            }
            else {
                setDisable(false)
                toasterrormsg(res.message)
            }
        }

    }
    // space Details api call
    const tourPackageDetailsApiCall = async () => {

        var param: any = {
            tourpackageId: String(editTourpackageId),
        }
        var response: any = await fetchData("public/tourpackageDetails", param)

        if (response.status == "200") {
            setTourPackageDetails(response.data);
            var data = response.data[0];
            const isAllStepsCompleted = Object.values(data['completedSteps']).every(s => s == true)
            if (isAllStepsCompleted && editTourpackageId !== "") {
                // Set all fields to true
                setIsFieldDisable((prev: any) => {
                    const updatedFields = {} as any;
                    for (const key in prev) {
                        updatedFields[key] = true;
                    }
                    return updatedFields;
                });
            }
            setPrimaryLanguageSelectedOptions({ value: data.primaryLanguage, label: `${data.primaryLanguage}` })
            setTourAgencyNameEN(data.en_agencyName)
            setTourAgencyNameRU(data.ru_agencyName)
            setTourAgencyNameUZ(data.uz_agencyName)
            setContactPersonName(data.contact_person_name)
            setEmail(data.email)
            setPhoneNumber(data.phoneNo)
            setSocialMediaFields(data.socialMediaChannels)
        }
        else {
            toasterrormsg(response.message)
        }
    }
    useEffect(() => {
        if (editTourpackageId != "") {
            tourPackageDetailsApiCall();
        }
    }, [])

    const criticalFieldChange = (field: string) => {
        Swal.fire({
            title: t('Please note that modifying this detail will require the preparation and signing of a new contract to ensure all parties are in agreement with the revised terms!'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('Ok'),
            cancelButtonText: t('Cancel'),
        }).then(async (result) => {
            if (result.isConfirmed) {
                setIsFieldDisable((prev: any) => ({
                    ...prev,
                    [field]: false,
                }));
            }
        });
    }
    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{editTourpackageId != "" ? t('Edit Tour Package') : t('Add Tour Package')}</PageTitle>
            <AddTourPackageHeader tourpackageId={editTourpackageId} />
            <div className="d-flex flex-column flex-column-fluid">
                {/* <!--begin::Content--> */}
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    {/* <!--begin::Form--> */}
                    <div className="form d-flex flex-column flex-lg-row">
                        {/* <!--begin::Main column--> */}
                        <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                            {/* <!--begin::Tab content--> */}
                            <div className="tab-content">
                                {/* <!--begin::Tab pane--> */}
                                <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">
                                    <div className="d-flex flex-column">
                                        {/* <!--begin::General options--> */}
                                        <div className="card card-flush py-4">
                                            {/* <!--begin::Card header--> */}
                                            <div className="card-header d-flex">
                                                {/* <!--begin::Card title--> */}
                                                <div className="card-title">
                                                    <h2>{t('Tour Package Basic Information')}</h2>
                                                </div>
                                                {/* <!--end::Card title--> */}
                                                <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                                                    {
                                                        tourPackageDetails.length != 0 ? (
                                                            <>
                                                                {
                                                                    tourPackageDetails.map((completedSteps: any, index: any) => {
                                                                        var percentage = 0;
                                                                        if (completedSteps['completedSteps']['basicInfo']) {
                                                                            percentage = 10;
                                                                        }
                                                                        if (completedSteps['completedSteps']['location']) {
                                                                            percentage = 20;
                                                                        }
                                                                        if (completedSteps['completedSteps']['toursDetail']) {
                                                                            percentage = 60;
                                                                        }
                                                                        if (completedSteps['completedSteps']['photos']) {
                                                                            percentage = 70;
                                                                        }
                                                                        if (completedSteps['completedSteps']['policies']) {
                                                                            percentage = 90;
                                                                        }
                                                                        if (completedSteps['completedSteps']['financeAndLegal']) {
                                                                            percentage = 100;
                                                                        }
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                                    <span className='fw-bolder fs-6'>{percentage}%</span>
                                                                                </div>
                                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                                    <div
                                                                                        className='bg-success rounded h-5px'
                                                                                        role='progressbar'
                                                                                        style={{ width: `${percentage}%` }}
                                                                                    ></div>
                                                                                </div>
                                                                            </React.Fragment>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                    <span className='fw-bolder fs-6'>0%</span>
                                                                </div>
                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                    <div
                                                                        className='bg-success rounded h-5px'
                                                                        role='progressbar'
                                                                        style={{ width: '0%' }}
                                                                    ></div>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            {/* <!--end::Card header--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-10">
                                                {/* <!--begin::Input group--> */}
                                                <div className="row">
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 form-label required">{t('Primary Language')}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <Select
                                                            name='primaryLanguage[]'
                                                            id='primaryLanguage'
                                                            placeholder={t('Select Primary Language')}
                                                            isSearchable={true}
                                                            options={primaryLanguageList}
                                                            value={primaryLanguageSelectedOptions}
                                                            onChange={(e: any) => { changePrimaryLanguage(e) }}
                                                        />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].primaryLanguage}</div>
                                                    </div>

                                                </div>
                                                {/* <!--end::Input group--> */}
                                            </div>
                                            {/* <!--end::Card body--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-0">
                                                {
                                                    primaryLanguageSelectedOptions.value == "English" && (
                                                        <>
                                                            {/* <!--begin::Input group--> */}
                                                            <div className="row">
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="required fs-4 form-label">{t('Tour Agency Name (English)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('tourAgencyNameEN')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="tourAgencyNameEN" disabled={isFieldDisable.tourAgencyNameEN} className="form-control mb-2" placeholder={t("Tour Agency Name")} value={tourAgencyNameEN} onChange={(e) => { setTourAgencyNameEN(e.target.value); removeError("tourAgencyNameEN"); }} />
                                                                    {/* <!--end::Input--> */}
                                                                    <div className='text-danger fw-bold'>{error[0].tourAgencyNameEN}</div>
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Tour Agency Name (Russian)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('tourAgencyNameRU')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="tourAgencyNameRU" disabled={isFieldDisable.tourAgencyNameRU} className="form-control mb-2" placeholder={t("Tour Agency Name")} value={tourAgencyNameRU} onChange={(e) => { setTourAgencyNameRU(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Tour Agency Name (Uzbek)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('tourAgencyNameUZ')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="tourAgencyNameUZ" disabled={isFieldDisable.tourAgencyNameUZ} className="form-control mb-2" placeholder={t("Tour Agency Name")} value={tourAgencyNameUZ} onChange={(e) => { setTourAgencyNameUZ(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Input group--> */}
                                                        </>
                                                    )
                                                }
                                                {
                                                    primaryLanguageSelectedOptions.value == "Russian" && (
                                                        <>
                                                            {/* <!--begin::Input group--> */}
                                                            <div className="row">
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="required fs-4 form-label">{t('Tour Agency Name (Russian)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('tourAgencyNameRU')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="tourAgencyNameRU" disabled={isFieldDisable.tourAgencyNameRU} className="form-control mb-2" placeholder={t("Tour Agency Name")} value={tourAgencyNameRU} onChange={(e) => { setTourAgencyNameRU(e.target.value) }} />
                                                                    <div className='text-danger fw-bold'>{error[0].tourAgencyNameRU}</div>
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Tour Agency Name (English)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('tourAgencyNameEN')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="tourAgencyNameEN" disabled={isFieldDisable.tourAgencyNameEN} className="form-control mb-2" placeholder={t("Tour Agency Name")} value={tourAgencyNameEN} onChange={(e) => { setTourAgencyNameEN(e.target.value); removeError("tourAgencyNameEN"); }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Tour Agency Name (Uzbek)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('tourAgencyNameUZ')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="tourAgencyNameUZ" disabled={isFieldDisable.tourAgencyNameUZ} className="form-control mb-2" placeholder={t("Tour Agency Name")} value={tourAgencyNameUZ} onChange={(e) => { setTourAgencyNameUZ(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Input group--> */}
                                                        </>
                                                    )
                                                }
                                                {
                                                    primaryLanguageSelectedOptions.value == "Uzbek" && (
                                                        <>
                                                            {/* <!--begin::Input group--> */}
                                                            <div className="row">
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="required fs-4 form-label">{t('Tour Agency Name (Uzbek)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('tourAgencyNameUZ')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="tourAgencyNameUZ" disabled={isFieldDisable.tourAgencyNameUZ} className="form-control mb-2" placeholder={t("Tour Agency Name")} value={tourAgencyNameUZ} onChange={(e) => { setTourAgencyNameUZ(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                    <div className='text-danger fw-bold'>{error[0].tourAgencyNameUZ}</div>
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Tour Agency Name (Russian)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('tourAgencyNameRU')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="tourAgencyNameRU" disabled={isFieldDisable.tourAgencyNameRU} className="form-control mb-2" placeholder={t("Tour Agency Name")} value={tourAgencyNameRU} onChange={(e) => { setTourAgencyNameRU(e.target.value) }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                                <div className="col-lg-4 my-3">
                                                                    {/* <!--begin::Label--> */}
                                                                    <label className="fs-4 form-label">{t('Tour Agency Name (English)')}</label>
                                                                    <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('tourAgencyNameEN')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                                    {/* <!--end::Label--> */}
                                                                    {/* <!--begin::Input--> */}
                                                                    <input type="text" name="tourAgencyNameEN" disabled={isFieldDisable.tourAgencyNameEN} className="form-control mb-2" placeholder={t("Tour Agency Name")} value={tourAgencyNameEN} onChange={(e) => { setTourAgencyNameEN(e.target.value); removeError("tourAgencyNameEN"); }} />
                                                                    {/* <!--end::Input--> */}
                                                                </div>
                                                            </div>
                                                            {/* <!--end::Input group--> */}
                                                        </>
                                                    )
                                                }
                                            </div>
                                            {/* <!--end::Card body--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-0">
                                                {/* <!--begin::Input group--> */}
                                                <div className="row">
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="required fs-4 form-label">{t('Contact Person Name')}</label>
                                                        <button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('contactPersonName')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <input type="text" name="contactPersonName" disabled={isFieldDisable.contactPersonName} className="form-control mb-2" placeholder={t("Contact Person Name")} value={contactPersonName} onChange={(e) => { setContactPersonName(e.target.value); removeError("contactPersonName"); }} />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].contactPersonName}</div>
                                                    </div>
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 form-label required">{t('Email')}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <input type="text" name="email" className="form-control mb-2" placeholder={t("Email")} value={email} onChange={(e) => { setEmail(e.target.value); removeError("email"); }} />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].email}</div>
                                                    </div>
                                                    <div className="col-lg-4 my-3">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 form-label required">{t('Phone Number')}</label>
                                                        {/* <!--end::Label--> */}
                                                        {/* <!--begin::Input--> */}
                                                        <PhoneInput
                                                            inputClass="form-control form-control-lg form-control-solid w-100"
                                                            placeholder={t('Phone Number')}
                                                            enableSearch={true}
                                                            value={phoneNumber}
                                                            onChange={(e) => { setPhoneNumber(e); removeError("phoneNumber"); }}
                                                        />
                                                        {/* <!--end::Input--> */}
                                                        <div className='text-danger fw-bold'>{error[0].phoneNumber}</div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Input group--> */}
                                            </div>
                                            <div className="card-body pt-0">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        {/* <!--begin::Label--> */}
                                                        <label className="fs-4 form-label required">{t('Social Media Channel')}</label>
                                                        {/* <!--end::Label--> */}
                                                    </div>
                                                </div>
                                                {socialMediaFields.map((field, index) => (
                                                    <div className='row' key={index}>
                                                        <div className="col-lg-4 my-3">
                                                            <Select
                                                                name='socialMediaChannels[]'
                                                                id={`socialMediaChannels-${index}`}
                                                                placeholder={t('Select Social Media Channels')}
                                                                isSearchable={true}
                                                                options={getFilteredOptions(index)}
                                                                value={socialMediaChannelList.find(option => option.value === field.socialMediaType)}
                                                                onChange={(selectedOption: any) => handleChange(index, 'socialMediaType', selectedOption.value)}
                                                            />
                                                            {errors[index]?.socialMediaType && <div className="text-danger fw-bold">{errors[index].socialMediaType}</div>}
                                                        </div>
                                                        <div className="col-lg-4 my-3">
                                                            <input
                                                                type="text"
                                                                className='form-control mb-2'
                                                                name='socialMediaLinks'
                                                                id={`socialMediaLinks-${index}`}
                                                                placeholder={t('Social Media Link')}
                                                                value={field.socialMediaLink}
                                                                onChange={(e) => handleChange(index, 'socialMediaLink', e.target.value)}
                                                            />
                                                            {errors[index]?.socialMediaLink && <div className="text-danger fw-bold">{errors[index].socialMediaLink}</div>}
                                                        </div>
                                                        <div className="col-lg-4 my-3">
                                                            <button className='btn btn-success mx-1' type="button" onClick={handleAddField}>+</button>
                                                            {socialMediaFields.length > 1 && index != 0 && (
                                                                <button className='btn btn-danger mx-1' type="button" onClick={() => handleRemoveField(index)}>-</button>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        {/* <!--end::Pricing--> */}
                                    </div>
                                </div>
                                {/* <!--end::Tab pane--> */}
                            </div>
                            {/* <!--end::Tab content--> */}
                            <div className="d-flex justify-content-end">
                                {/* <!--begin::Button--> */}
                                <Link to="../viewtourpackages/" id="kt_ecommerce_add_product_cancel" className="btn btn-light me-5">{t('Cancel')}</Link>
                                {/* <!--end::Button--> */}
                                {/* <!--begin::Button id="kt_ecommerce_add_product_submit"--> */}
                                <button type="submit" disabled={disable} className="btn btn-primary" onClick={() => { if (editTourpackageId !== "") { editTourPackageApi(); } else { addTourPackageApi(); } }}>
                                    <span className="indicator-label">{t('Next')}</span>
                                    {loading && (
                                        <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                </button>
                                {/* <!--end::Button--> */}
                            </div>
                        </div>
                        {/* <!--end::Main column--> */}
                    </div>
                    {/* <!--end::Form--> */}
                </div>
                {/* <!--end::Content--> */}
            </div>
        </>
    )
}

export { AddTourPackageBasicInfo }
